import { render, staticRenderFns } from "./TaxInvoiceResultV2026.vue?vue&type=template&id=16068dc2&scoped=true"
import script from "./TaxInvoiceResultV2026.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceResultV2026.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceResultV2026.vue?vue&type=style&index=0&id=16068dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16068dc2",
  null
  
)

export default component.exports